import { setLanguage as setMedicalClaimLanguage } from './medicalClaim';
import { setLanguage as setTravelClaimLanguage } from './travelClaim';
import { setLanguage as steAccidentClaimLanguage } from './accidentClaim';
import { setLanguage as setCascoClaimLanguage } from './cascoClaim';
import { setLanguage as setPropertyClaimLanguage } from './propertyClaim';
import { setLanguage as setCMTPLFormLanguage } from './cmtplForm';
import { setLanguage as setPersonalClaimLanguage } from './personalClaim';

const SET_ELEMENT_IS_FOCUSED = 'efes/global/SET_ELEMENT_IS_FOCUSED';

const initialState = {
  elementIsFocused: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ELEMENT_IS_FOCUSED:
      return {
        ...state,
        elementIsFocused: action.data,
      };
    default:
      return state;
  }
}

export const setElementFocusedState = (data) => ({
  type: SET_ELEMENT_IS_FOCUSED,
  data,
});

export const setFormsLanguage = (language) => (dispatch) => {
  dispatch(setMedicalClaimLanguage(language));
  dispatch(setTravelClaimLanguage(language));
  dispatch(steAccidentClaimLanguage(language));
  dispatch(setCascoClaimLanguage(language));
  dispatch(setPropertyClaimLanguage(language));
  dispatch(setCMTPLFormLanguage(language));
  dispatch(setPersonalClaimLanguage(language));
};
